























import Vue from 'vue';
import ruleVuex from '../../vuex/common';
import customerClient from '../../apis';
import moment from 'moment';

export default Vue.extend({
  mixins: [ruleVuex],
  props: {
    ruleId: {
      type: Number,
      default: null,
    },
    type: {
      type: Number,
      default: null,
    },
    sid: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      start: moment().subtract('days', 1).format('YYYY-MM-DD hh:mm:ss'),
      end: moment().format('YYYY-MM-DD hh:mm:ss'),
      todayCount: 0,   
      yesterdayCount: 0,
      totalCount: 0,
    };
  },
  methods: {
    getIndicatorData() {
      customerClient.getRemarkRuleIndicators({
        ruleId: this.ruleId,
        type: this.type,
        sid: this.sid,
      }).success((r) => {
        this.yesterdayCount = r.yesterday;
        this.todayCount = r.today;
        this.totalCount = r.all;
      });
    },
  },
  mounted() {
    this.getIndicatorData();
  },
});
